import {
    Box,
    Button,
    FormControl,
    TextField,
    Typography,
    Grid
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../../components/base/BasicDialog/BasicDialog";
import { useState } from "react";
import SelectFieldService from "../../../services/selectFieldService";
import TextFieldFormControl from "../../field/TextFieldFormControl";
import { fontWeight, textAlign } from "@mui/system";
import { useSetPersonClauseMutation } from "../../../services/clausesService";
import { useToasts } from "../../../hooks/useToasts";
import toast from "react-hot-toast"
import { SnackbarSuccess } from "../../../components/base/SnackbarAlert/SnackbarSuccess";
import CheckboxField from "../../base/CheckboxField/checkboxField";


export default function ConfirmChangePersonClauseDialog({ open, onClose, clauseId, clauseName, personId, personName, clauseDecision, dialogTitle}) {
    const { t } = useTranslation();
    const { onFormErrors, onServerError } = useToasts();
    const { mutate: setPersonClause, isPending } = useSetPersonClauseMutation({
        onSuccess: (data, variables, context) => {
            toast.custom(
                () => <SnackbarSuccess message={t("successfullyEditedClause")} />,
                {
                    position: "bottom-right",
                },
            );
            onClose()
        },
        onError: (error) => {
            onServerError(error);
        },
    });
    const [clauseComment, setClauseComment] = useState()
    const [sendEmail, setSendEmail] = useState(false)
    const clauseInfo = (
        <div style={{fontSize: "17px"}}>
            {"Czy na pewno chcesz zmienic zgodę "}
            <span style={{fontWeight:"bold"}}>{clauseName}</span>
            {" klientowi "}
            <span style={{fontWeight:"bold"}}>{personName}</span>
            {" na "}
            <span style={{fontWeight:"bold"}}>{SelectFieldService.getLabelOptionsYesOrNo(clauseDecision).toLocaleUpperCase()}</span>
        </div> 
    )

    
    const onSubmit = () => {
        setPersonClause({
            clauseId:clauseId,
            personId: personId,
            value: clauseDecision,
            clauseComment: clauseComment,
            sendEmail: sendEmail,
        })
    };

    return (
        <BasicDialog
            open={open}
            onClose={onClose}
            title={dialogTitle || t("clients.PersonClausesDialog.ConfirmChangePersonClauseDialogTitle")}
            maxWidth="sm"
            titleSx={{textAlign: "center"}}
            showBottomCloseButton={false}
            showDialogActions={false}
        >
                <Grid container>
                    <Grid item xs={12}>
                        <Typography 
                            // sx={{fontWeight: "bold"}}

                        >
                            {clauseInfo}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextFieldFormControl
                            sx={{marginBlock: 2}}
                            value={clauseComment}
                            label={`${t("clients.PersonClausesDialog.table.comment")}*`}
                            onChange={(e)=>{setClauseComment(e.target.value)}}
                            multiline
                            rows={4}
                        />
                    </Grid>
                    <Grid
                        item 
                        xs={12}
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs={6} textAlign={"right"}>
                            <LoadingButton
                                style={{ minWidth: "100px" }}
                                variant="contained"
                                size="small"
                                onClick={onSubmit}
                                color={"success"}
                                loading={isPending}
                                disabled={!clauseComment || isPending}
                            >
                                {t("confirm")}
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={6} textAlign={"left"}>
                            <Button
                                color={"error"}
                                style={{ minWidth: "100px" }}
                                variant="contained"
                                size="small"
                                onClick={onClose}
                                disabled={isPending}
                            >
                                {t("refuse")}
                            </Button>
                        </Grid>
                    </Grid>
                    {clauseDecision === true && <Grid item xs={12} sx={{marginBlock: 1}}>
                        <CheckboxField
                            checked={sendEmail}
                            label={`${t("clients.PersonClausesDialog.sendAutoresponderToClient")}`}
                            onChange={(e)=>{setSendEmail(e.target.checked)}}
                        />
                    </Grid>}
                </Grid>
        </BasicDialog>
    );
}